import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
    APP_INITIALIZER,
    ApplicationConfig,
    ErrorHandler,
    importProvidersFrom,
    provideZonelessChangeDetection,
} from '@angular/core';
import {
    provideRouter,
    Router,
    withComponentInputBinding,
    withRouterConfig,
    withViewTransitions,
} from '@angular/router';
import * as Sentry from '@sentry/angular';
import { provideAngularSvgIcon } from 'angular-svg-icon';

import { routes } from '@connect-services/client/app/app.routes';
import { BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { environment } from '@connect-services/client/environments/environment';
import { httpAcceptLanguageInterceptor } from '@connect-services/client/interceptors/http-accept-language.interceptor';
import { httpApplicationNameInterceptor } from '@connect-services/client/interceptors/http-application-name';
import { httpErrorsInterceptor } from '@connect-services/client/interceptors/http-errors.interceptor';
import { ApiModule, Configuration } from '@connect-services/client/sdk/api';
import { SecurityService } from '@connect-services/client/services/security.service';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { TranslocoRootModule } from '@transloco-root/client/transloco-root.module';

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom([
            // Imports providers of "RessourcesModule" to resolve dependencies.
            // eg: "SecurityService -> SnackBarService -> MatSnackBar"
            // or: "FormService -> ByteFormatPipe"
            // It only adds these providers and "RessourcesModule" has to be imported in components via "import" property of "@Component" if needed.
            RessourcesModule,
            TranslocoRootModule,
            ApiModule.forRoot(() => {
                return new Configuration({
                    basePath: environment.baseApiUrl,
                    credentials: {
                        bearer: (): string | undefined => SecurityService.getAccessToken() ?? undefined,
                    },
                });
            }),
        ]),
        provideRouter(routes),
        provideHttpClient(
            withInterceptors([httpErrorsInterceptor, httpAcceptLanguageInterceptor, httpApplicationNameInterceptor]),
        ),
        provideAngularSvgIcon(),
        {
            provide: BLOC_DEBUG,
            useValue: false,
        },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            deps: [Router],
            provide: Sentry.TraceService,
        },
        {
            deps: [Sentry.TraceService],
            multi: true,
            provide: APP_INITIALIZER,
            useFactory: () => () => {}, //eslint-disable-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/no-empty-function
        },
        provideRouter(
            routes,
            withComponentInputBinding(),
            withRouterConfig({
                onSameUrlNavigation: 'reload',
                paramsInheritanceStrategy: 'always',
            }),
            withViewTransitions(),
        ),
        provideZonelessChangeDetection(),
    ],
};
